






import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Edr extends Vue {}
